import { useEffect, useState } from 'react';
import { VacationsRequest } from '../models/RequestDetails.interface';
import axios from 'axios';

export const useGetRequestDetails = (requestId?: string, year?: number) => {
  const [requestDetails, setRequestDetails] = useState<VacationsRequest>();
  const [loadingRequestDetails, setLoadingRequestDetails] = useState<boolean>();

  const getRequestDetails = async () => {
    try {
      setLoadingRequestDetails(true);
      const { data } = await axios.get(
        `api/vacation-requests/my/${year}?id=${requestId}`
      );
      data && setRequestDetails(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingRequestDetails(false);
    }
  };

  useEffect(() => {
    getRequestDetails();
  }, [requestId, year]);

  return {
    requestDetails,
    loadingRequestDetails,
  };
};
